
// TODO Вынести общие для статистики и саппорта классы в папку models.
// Только аккуратно, там уже понамещано
import { Invoice } from "./billing.model";

export class User {
	_id?: string;
	allowFreemium?: boolean;
	created?: string;
	createdIP?: string;
	createdLang?: string;
	email?: string;
	firstReferer?: string;
	createdReferer?: string;
	markedReferer?: string;
	isBan?: boolean;
	lastAuthDate?: string;
	lastAuthIP?: string;
	lastAuthLang?: string;
	note?: string;
	phone?: string;
	pro?: boolean;
	role?: string;
	useTariffsMixins?: boolean;
	username = 'test';
	admin?: boolean;
	accessor?: boolean;
	tariffFeaturesData?: any;
	socialList?: any[];
	countReReg = 0;
	experiments: any[];
	currency?: string;
	hardbounce?: boolean;
	phonesFromSites?: string[] = [];
	phonesFromExternalData?: string[] = [];
	isConfirm?: boolean;
	createdCountry?: string;
	createdCity?: string;
	lastAuthCountry?: string;
	lastAuthCity?: string;
	affiliates?: object = {
		Divly: false,
	};
	referers?: object;
	phonesFromUser?: string[];
	affiliate?: string;
	isExcluded?: boolean;
}

interface PromopultSite {
	balance: number;
	status: string;
}

export class Site {
	_id = '';
	pages: string[] = [];
	pageCount?: number;
	url: string;
	zoneDomain: string;
	dateCreate: number|string;
	domainUrl: string;
	invoices: Invoice[];
	_source: number;
	lastDisableRec: string = '';
	promopult?: PromopultSite;
	
	// Поле содержит рекурентный профиль активного инвойса
	recurrentProfile?: string[];
	
	// Список всех  рекурентных профилей всех инвойсов сайта
	recurrentProfiles: string[];
	_trialExpiration: string;
	dateTrialStart: string;
	isBlock: boolean;
	paidType: string;
	_paidExpiration: string;
	isSeoUber: boolean;
	multilangParentId: string;
	inFreemiumMode: boolean;
	isUber: boolean;
	userId: string;
	techUrl: string;
}

export class FilterSearch {
	site ? = '';
	accurateSiteSearch ? = true;
	email ? = '';
	username ? = '';
	invoiceNumber ? = '';
	sitePage ? = 1;
}


export class SuportSearchResult {
	userId = '';
	siteIdList: string[] = [];
}


export class UserInfo {
	user: User = null;
	appDataList: object[] = [];
}
